import Modal, { ModalHTMLElement } from './modal';

export function initMyOrdersCancelButton() : void {
    document.querySelectorAll<HTMLButtonElement>('.js-my-orders-cancel-button').forEach($myOrdersCancelButton => {
        new MyOrdersCancelButton($myOrdersCancelButton);
    });
}

export class MyOrdersCancelButton {
    $button: HTMLButtonElement;
    orderGuid: string|null;
    $modal: ModalHTMLElement|null;
    $modalOrderGuidInput: HTMLInputElement|null = null;

    constructor($button: HTMLButtonElement) {
        this.$button = $button;
        this.orderGuid = this.$button.dataset.orderGuid || null;
        this.$modal = document.querySelector('#' + $button.dataset.modalTarget);

        if (this.orderGuid && this.$modal) {
            this.$modalOrderGuidInput = this.$modal.querySelector<HTMLInputElement>('.js-order-guid');

            this.$button.addEventListener('click', () => {
                if (this.$modalOrderGuidInput && this.orderGuid) {
                    this.$modalOrderGuidInput.value = this.orderGuid;
                }

                if (this.$modal) {
                    Modal.openModal(this.$modal);
                }
            });
        }
    }
}
